import Shared from "emun.cart/cart.controller";
import resolve from "ioc/resolve";
import templateUrl from "emun.cart/cart-scan.htm";
import AutoQuery from "servicestack/auto-query/auto-query.es6";
import Product from "emun.shopping/product.model";

class CartScanController extends Shared {
  constructor($cart, $state, createAutoQuery, createServiceBus, modals, utils) {
    super($cart);
    let $stateParams = resolve("$stateParams");
    if ($stateParams.cartId) $cart.load($stateParams.cartId);
    this.prodQuery = new AutoQuery({
      url: "QueryProducts.json",
      autoLoad: false,
      pageSize: 5,
      onLoaded: (args) => {
        this.products = Product.map(args.results);
        if (args.results.length == 1) {
          this.invalid = false;
          this.product = this.products[0];
          this.product.qtyToAdd = this.product.minimumOrderQty || 1;
          this.product.shipDate = this.$cart.shipOn;
        } else if (args.results.length == 0) {
          this.invalid = true;
        }
      },
    });
    this.$on("cartItemAdded", function () {
      $cart.load($cart.cartId);
    });
    this.getProduct = function (id) {
      this.query = new AutoQuery({
        url: "QueryProducts.json?Take=1&Id=" + id,
        autoLoad: true,
        onLoaded: (args) => {
          if (args.first) {
            this.invalid = false;
            this.product = Product.map(args.results)[0];
            this.product.qtyToAdd = this.product.minimumOrderQty || 1;
            this.product.shipDate = this.$cart.shipOn;
          }
        },
      });
    };
    this.addProduct = function () {
      var item = {
        cartId: $cart.id,
        productId: this.product.id,
        quantity: this.product.qtyToAdd,
      };
      $cart.addItem(item, this.product, false);
      this.product = null;
      this.prodQuery.criteria.search = "";
      this.products = [];
    };
    this.clear = function () {
      this.product = null;
      this.prodQuery.criteria.search = "";
      this.products = [];
    };
  }
}

export default {
  controller: CartScanController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
